import React, { useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useIsPremiumFeatureEnabled } from '@/hooks';
import { ROUTE } from '@/router/routes';

export const PremiumFeatureRoute = ({
    children,
}: {
    children: React.ReactNode;
}) => {
    const { isPremiumFeatureEnabled, loading: establishingPremiumFlag } =
        useIsPremiumFeatureEnabled();
    const navigate = useNavigate();

    const redirectToDashboard = useCallback(() => {
        if (!establishingPremiumFlag && !isPremiumFeatureEnabled) {
            navigate(ROUTE.dashboard);
        }
    }, [establishingPremiumFlag, isPremiumFeatureEnabled, navigate]);

    useEffect(redirectToDashboard);

    return establishingPremiumFlag ? null : <>{children}</>;
};
